export default "__VITE_ASSET__CHf56I3l__"